module.exports = __webpack_public_path__ + "img/multiple-letter-icon.c3d364f3.svg";